import { render } from "./ResourceLabel.vue?vue&type=template&id=d51d5c74&scoped=true"
import script from "./ResourceLabel.vue?vue&type=script&lang=js"
export * from "./ResourceLabel.vue?vue&type=script&lang=js"

import "./ResourceLabel.vue?vue&type=style&index=0&id=d51d5c74&lang=scss&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51d5c74"]])

export default __exports__